export default "__VITE_ASSET__4392ceac__"